/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_MissingInputs */

const cs_deal_provision_missing = /** @type {(inputs: Deal_Provision_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavte provizi, aby pipeline a výplaty dávaly smysl.`)
};

const en_deal_provision_missing = /** @type {(inputs: Deal_Provision_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set commission so pipeline and payouts stay accurate.`)
};

/**
* | output |
* | --- |
* | "Set commission so pipeline and payouts stay accurate." |
*
* @param {Deal_Provision_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_missing = /** @type {((inputs?: Deal_Provision_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_missing(inputs)
	return cs_deal_provision_missing(inputs)
});